import { parsePhoneNumber } from 'libphonenumber-js/core';
import metadata from './phone-metadata.json';

/**
 * Normalize phone number for API calls: E.164 format (e.g., +31612345678)
 * Returns plus sign followed by digits only, no spaces or other formatting.
 * Falls back to original if parsing fails.
 */
export function normalizeTelephone(phone) {
    if (!phone || !phone.trim()) return phone;

    try {
        const phoneNumber = parsePhoneNumber(phone, 'NL', metadata);
        if (phoneNumber && phoneNumber.isValid()) {
            return phoneNumber.format('E.164');
        }
    } catch (error) {
        // Fall through
    }

    // Foreign international numbers can't be parsed with the NL-only
    // metadata; strip formatting to E.164 shape manually.
    const trimmed = phone.trim();
    if (trimmed.startsWith('+')) {
        const digits = trimmed.replace(/\D/g, '');
        if (digits.length >= 10) return '+' + digits;
    }

    return phone;
}
